export const useStyles = (theme) => ({
  formStyle: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 30,
  },
  labelStyle: {
    padding: 10,
    fontSize: 25,
    cursor: "pointer",
    backgroundColor: "#eee",
    borderRadius: 10,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  messageLoading: {
    fontSize: 25,
    fontWeight: "bold",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
});
